export default "__VITE_ASSET__DQFGEmLC__"